import type { StorePlatform } from "@-/dev.improve.haniverse.components.website";

export type LandingScreenshot = {
  alt: string;
  height: number;
  platform: StorePlatform;
  src: string;
  width: number;
};

/**
 * Real captures of the native app, served from `apps/haniverse-expo/public/landing` as 750px-wide
 * WebP. iOS shots come from an iPhone 17 simulator (1206×2622, status bar pinned to 9:41 with
 * `simctl status_bar`; the capture already includes the Dynamic Island). Android shots come from a
 * 1080×2400 emulator in SystemUI demo mode.
 */
function iosScreenshot(name: string, alt: string): LandingScreenshot {
  return { alt, height: 1631, platform: "ios", src: `/landing/ios-${name}.webp`, width: 750 };
}

function androidScreenshot(name: string, alt: string): LandingScreenshot {
  return {
    alt,
    height: 1667,
    platform: "android",
    src: `/landing/android-${name}.webp`,
    width: 750,
  };
}

export const LANDING_SCREENSHOTS = {
  androidMnemonic: androidScreenshot(
    "mnemonic",
    "A Haniverse lesson on Android explaining that 明 (bright) is built from 日 sun and 月 moon",
  ),
  androidReview: androidScreenshot(
    "review",
    "A Haniverse review on Android revealing 三 (three) with Again, Hard, Good and Easy buttons",
  ),
  androidReviewQuestion: androidScreenshot(
    "review-question",
    "A Haniverse review on Android asking what 三 means, with a box to type the answer",
  ),
  androidSearch: androidScreenshot(
    "search",
    "Haniverse search results on Android for “moon”, with tone-colored pinyin and meanings",
  ),
  iosBrowse: iosScreenshot("browse", "Browsing characters by HSK level in Haniverse on iPhone"),
  iosCharacter: iosScreenshot(
    "character",
    "The details of 明 in Haniverse on iPhone: HSK level, components, frequency rank and definitions",
  ),
  iosLesson: iosScreenshot(
    "lesson",
    "A new-character lesson for 好 in Haniverse on iPhone, with its stroke-order animation",
  ),
  iosMnemonic: iosScreenshot(
    "mnemonic",
    "A Haniverse lesson on iPhone explaining that 明 (bright) is built from 日 sun and 月 moon",
  ),
  iosSearch: iosScreenshot(
    "search",
    "Haniverse search results on iPhone for “water”, with tone-colored pinyin and meanings",
  ),
  iosStrokes: iosScreenshot(
    "strokes",
    "The stroke order of 明 on a practice grid in Haniverse on iPhone",
  ),
} satisfies Record<string, LandingScreenshot>;
